
import { Users } from "lucide-react";
import PageLayout from "@/components/layout/PageLayout";
import { CompetitorAnalysis as CompetitorAnalysisComponent } from "@/components/ted-analysis/CompetitorAnalysis";
import { Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";

const CompetitorAnalysisPage = () => {
  const { t } = useTranslation('competitorAnalysis');
  
  return (
    <PageLayout title={t('pageTitle')} description={t('pageDescription')} icon={<Users className="h-6 w-6" />}>
      <div className="container max-w-7xl mx-auto py-6">
        <Suspense fallback={<AnalysisLoadingSkeleton />}>
          <CompetitorAnalysisComponent />
        </Suspense>
      </div>
    </PageLayout>
  );
};

const AnalysisLoadingSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Skeleton className="h-[120px] w-full rounded-lg" />
        <Skeleton className="h-[120px] w-full rounded-lg" />
        <Skeleton className="h-[120px] w-full rounded-lg" />
      </div>
      <Skeleton className="h-[300px] w-full rounded-lg" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Skeleton className="h-[250px] w-full rounded-lg" />
        <Skeleton className="h-[250px] w-full rounded-lg" />
      </div>
    </div>
  );
};

export default CompetitorAnalysisPage;
